<template>
  <div v-once>
    <SectionHero :value="{ title: legalPage.title }" />
    <SectionText :value="{ description: legalPage.body }" class="mb-16" />
  </div>
</template>

<script setup>
import SectionHero from '#root/components/sections/section_hero.vue'
import SectionText from '#root/components/sections/section_text.vue'

defineProps({
  legalPage: {
    required: true,
    type: Object
  }
})
</script>
